// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * @private
 */
export interface ConfigurationPageCameraDropdownProps {
  cameraGrantedDropdown: JSX.Element;
  cameraPermissionGranted: boolean;
  onClickEnableDevicePermission?: () => void;
  ariaLabelledby?: string;
}

/**
 * @private
 */
export const ConfigurationPageCameraDropdown = (props: ConfigurationPageCameraDropdownProps): JSX.Element => {
  return props.cameraGrantedDropdown;
};